export function getAll() {
  return [
    {
      value: 0,
      name: "None",
      text: "無",
    },
    {
      value: 1,
      name: "OverCharge",
      text: "溢收",
    },
    {
      value: 2,
      name: "CashChange",
      text: "現金找零",
    },
    {
      value: 3,
      name: "Change",
      text: "找零",
    },
  ];
}
